import clsx from 'clsx';
import { useTranslation } from 'next-i18next/pages';
import Image from 'next/image';
import React from 'react';
import { twMerge } from 'tailwind-merge';

import YouTubePortal from '../youtube-portal';

export interface VideoButtonProps {
  imgSrc: string;
  videoId: string;
  circle?: boolean;
  className?: string;
  shouldShowVideo?: boolean;
  alt?: string;
}

const VideoButton: React.FC<VideoButtonProps> = ({ imgSrc, videoId, circle, className, shouldShowVideo = true, alt = 'playVideo' }) => {
  const { t } = useTranslation('landingPage', { keyPrefix: 'videoButton' });
  const [isVideoVisible, showVideo] = React.useState(false);

  const image = (
    <Image
      alt={alt}
      className={clsx(circle ? 'rounded-full object-cover' : 'rounded-2xl object-cover')}
      fill
      src={imgSrc}
      sizes='(max-width: 640px) 50vw, (max-width: 828px) 40vw, 100vw'
    />
  );

  const sharedStyles = twMerge(
    clsx(
      'relative shrink-0 transition-all duration-300 hover:shadow-xl hover:brightness-105',
      circle ? 'md:h-70 md:w-70 h-36 w-36 rounded-full border-4 border-white shadow-md' : 'w-full rounded-2xl',
      className,
    ),
  );

  return shouldShowVideo ? (
    <button className={sharedStyles} onClick={() => showVideo(true)}>
      {image}
      <Image alt={t('playVideo')} height={60} className='relative m-auto' src='/assets/play-circle.svg' width={60} />
      {isVideoVisible && <YouTubePortal autoPlay onDismiss={() => showVideo(false)} videoId={videoId} />}
    </button>
  ) : (
    <div className={sharedStyles}>{image}</div>
  );
};

export default VideoButton;
